/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_ClassesInputs */

const da_privacy_data_classes = /** @type {(inputs: Privacy_Data_ClassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Klasser og elever:** klasser samt elevernes numre og aliasser. Skriv ikke elevernes rigtige navne. Brug numre eller aliasser, som kun du kan koble til en elev.`)
};

/** @type {(inputs: Privacy_Data_ClassesInputs) => LocalizedString} */
const en_privacy_data_classes = da_privacy_data_classes;

/**

* @param {Privacy_Data_ClassesInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_classes = /** @type {((inputs?: Privacy_Data_ClassesInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_ClassesInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_classes(inputs)
	return /** @type {LocalizedString} */ ("**Klasser og elever:** klasser samt elevernes numre og aliasser. Skriv ikke elevernes rigtige navne. Brug numre eller aliasser, som kun du kan koble til en elev.")
});